import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { APIService, UploadedMapImage } from '../../services/APIService';

@Component({
  selector: 'app-map-images',
  templateUrl: './map-images.component.html',
  styleUrls: ['./map-images.component.css']
})
export class MapImagesComponent implements OnInit {
  images: UploadedMapImage[] = [];
  selectedFiles: File[] = [];
  loading = true;
  uploading = false;

  constructor(private api: APIService, private snack: MatSnackBar) {}

  ngOnInit(): void { this.loadImages(); }

  async loadImages(): Promise<void> {
    this.loading = true;
    try { this.images = await this.api.getUploadedMapImages(); }
    catch (e) { this.snack.open(this.errorMessage(e, 'Unable to load map images'), 'Dismiss', { duration: 5000 }); }
    finally { this.loading = false; }
  }

  chooseFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selectedFiles = input.files ? Array.from(input.files) : [];
  }

  async upload(): Promise<void> {
    if (!this.selectedFiles.length) return;
    this.uploading = true;
    try {
      const results = await Promise.allSettled(this.selectedFiles.map(file => this.api.uploadMapImage(file)));
      const uploaded = results
        .filter((result): result is PromiseFulfilledResult<UploadedMapImage> => result.status === 'fulfilled')
        .map(result => result.value);
      const failed = results.length - uploaded.length;

      this.images = [...uploaded, ...this.images];
      this.selectedFiles = [];

      if (failed === 0) {
        this.snack.open(`${uploaded.length} map image${uploaded.length === 1 ? '' : 's'} uploaded`, 'OK', { duration: 3000 });
      } else {
        this.snack.open(`${uploaded.length} uploaded, ${failed} failed`, 'Dismiss', { duration: 5000 });
      }
    } catch (e) { this.snack.open(this.errorMessage(e, 'Image upload failed'), 'Dismiss', { duration: 5000 }); }
    finally { this.uploading = false; }
  }

  imageUrl(image: UploadedMapImage): string { return `${this.api.baseUrl}/asset/${image.asset}`; }

  async remove(image: UploadedMapImage): Promise<void> {
    try {
      await this.api.deleteUploadedMapImage(image.id);
      this.images = this.images.filter(i => i.id !== image.id);
      this.snack.open('Map image deleted', 'OK', { duration: 3000 });
    } catch (e) { this.snack.open(this.errorMessage(e, 'Unable to delete map image'), 'Dismiss', { duration: 5000 }); }
  }

  private errorMessage(error: any, fallback: string): string {
    return typeof error === 'string' ? error : error?.error?.message || error?.message || fallback;
  }
}
